import { useState, useEffect, useCallback } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios"; // backend will be commented
// import { API } from '../API';
import SchoolSidebar from "./SchoolSidebar";
import swal from "sweetalert";
import { useParams } from "react-router-dom";
// Mock Dropdown Data
const genders = ["Boy", "Girl"];

export default function SchoolUniformForm() {
  const { id } = useParams();
  const [form, setForm] = useState({
    enrollment: "",
    group: "",
    gender: "",
    grade: "",
    name: "",
    student: "",
    products: [],
    schoolId: localStorage.getItem("schoolID"),
  });

  const [products, setProducts] = useState([]);
  const [mode, setMode] = useState("");
  const [enrollmentNumbers, setEnrollmentNumbers] = useState([]);
  const [studentNames, setStudentNames] = useState([]);
  const [grades, setGrades] = useState([]);
  const [gorb, setGorB] = useState([]);
  const [data, setData] = useState([]);
  const [gOrbData, setGorbData] = useState([]);
  const [filledProducts, setFilledProducts] = useState([]);
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const resp = await axios.get(`/api/schooluniform/get-order/${id}`);
        setFilledProducts(resp.data.data.products);

        setForm((prev) => ({
          ...prev,
          ...resp.data.data,
          gender:
            resp.data.data.gender.charAt(0).toUpperCase() +
            resp.data.data.gender.slice(1),
        }));
      } catch (err) {
        console.error(err);
      }
    };
    fetchOrder();
  }, [id]);

  useEffect(() => {
    const fetchSchool = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get(
          `/api/schooluniform/get-students-by-school/${schoolId}`
        );
        const students = resp.data.data;
        const gOrb = resp.data.gOrb;

        // Extract dropdown values
        const enrollmentList = students.map((s) => s.enrollment_number);
        const studentNameList = students.map((s) => s.name);

        // Extract grade dropdown (store only grade._id)
        const gradeList = students.map((s) => ({
          id: s.grade?._id,
          name: s.grade?.name,
        }));

        const gOrbList = Array.from(
          new Map(
            gOrb.map((s) => [s._id, { id: s._id, name: s.name }])
          ).values()
        );

        // Optional: remove duplicates
        const uniqueGrades = Array.from(
          new Map(gradeList.map((g) => [g.id, g])).values()
        );

        // Update states
        setEnrollmentNumbers(enrollmentList);
        setStudentNames(studentNameList);
        setGrades(uniqueGrades);
        setGorB(gOrbList);
        setMode(resp.data.option);
        setData(students);
        setGorbData(gOrb);
        setGorB(gOrb);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSchool();
  }, []);

  useEffect(() => {
    if (!form.gender || !form.grade || !form.student) return;

    // Auto-fill enrollment
    const matchedStudent = data.find(
      (s) =>
        s.name === form.student &&
        s.gender === form.gender.toLowerCase() &&
        s.grade._id === form.grade
    );

    if (
      matchedStudent &&
      form.enrollment !== matchedStudent.enrollment_number
    ) {
      setForm((prev) => ({
        ...prev,
        enrollment: matchedStudent.enrollment_number,
      }));
    }

    // Filter gOrb based on gender + grade + optionally house
    const gOrbList = Array.from(
      new Map(
        gOrbData
          .filter(
            (g) =>
              g.gender === form.gender.toLowerCase() &&
              g.grades.includes(form.grade) &&
              matchedStudent &&
              g.house.toString() === matchedStudent.house.toString() // match house
          )
          .map((s) => [s._id, { _id: s._id, name: s.name }])
      ).values()
    );

    setGorB(gOrbList);

    // Auto-set form.group to first matching group (if any)
    if (gOrbList.length > 0 && form.group !== gOrbList[0]._id) {
      setForm((prev) => ({
        ...prev,
        group: gOrbList[0]._id,
      }));
    }
  }, [
    form.gender,
    form.grade,
    form.student,
    data,
    gOrbData,
    form.enrollment,
    form.group,
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === "enrollment") {
      const selectedStudent = data.find(
        (s) => s.enrollment_number === e.target.value
      );

      if (selectedStudent) {
        const genderLower = selectedStudent.gender.toLowerCase();
        const gradeId = selectedStudent.grade._id;

        setForm((prev) => ({
          ...prev,
          enrollment: e.target.value,
          student: selectedStudent.name,
          gender:
            selectedStudent.gender.charAt(0).toUpperCase() +
            selectedStudent.gender.slice(1),
          grade: gradeId,
        }));

        const gOrbList = Array.from(
          new Map(
            gOrbData
              .filter(
                (g) => g.gender === genderLower && g.grades.includes(gradeId)
              )
              .map((s) => [s._id, { _id: s._id, name: s.name }])
          ).values()
        );
        setGorB(gOrbList);
      }
    } else if (
      e.target.name === "student" ||
      e.target.name === "grade" ||
      e.target.name === "gender"
    ) {
    }
  };

  const handleSizeChange = (index, variantId) => {
    setForm((prev) => {
      const updated = [...prev.products];

      updated[index] = {
        ...updated[index],
        variantId: variantId || "",
      };

      return { ...prev, products: updated };
    });
  };

  const handleQuantityChange = (index, qty) => {
    const updated = [...form.products];
    updated[index].quantity = qty;

    setForm({ ...form, products: updated });
  };

  const getProducts = useCallback(async () => {
    if (!form.group || form.group === "") {
      return swal({
        title: "Missing Selection",
        text: `Please select a ${mode === "group" ? "Group" : "Bundle"} first.`,
        icon: "warning",
        button: "OK",
      });
    }

    try {
      const url =
        mode === "group"
          ? "/api/schooluniform/products-by-group"
          : "/api/schooluniform/products-by-bundle";

      const resp = await axios.get(url, {
        params: { gOrbId: form.group },
      });

      const {
        topwear = [],
        bottomwear = [],
        combined = [],
      } = resp.data.products;

      const finalProducts =
        combined.length > 0 ? combined : [...topwear, ...bottomwear];

      setProducts(finalProducts);

      setForm((prev) => {
        const filled = filledProducts || [];

        const mergedProducts = finalProducts.map((p) => {
          const existing = filled.find((fp) => fp.productId === p.productId);

          return existing
            ? {
                productId: p.productId,
                variantId: existing.variantId,
                quantity: existing.quantity,
              }
            : {
                productId: p.productId,
                variantId: "",
                quantity: mode === "group" ? 0 : p.quantity,
              };
        });

        return {
          ...prev,
          products: mergedProducts,
        };
      });
    } catch (err) {
      console.error(err);
      swal({
        title: "Error",
        text: "Failed to fetch products. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  }, [form.group, mode, filledProducts]);

  useEffect(() => {
    if (!form.group) return;
    if (!mode) return;
    getProducts();
  }, [form.group, getProducts,mode]);


  useEffect(() => {
    const fetchFilteredStudentNames = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");

        const resp = await axios.get("/api/schooluniform/filter-studentnames", {
          params: {
            schoolId,
            gender: form.gender ? form.gender.toLowerCase() : "",
            grade: form.grade || "",
          },
        });
        setStudentNames(resp.data.data);
      } catch (err) {
        console.error("Failed to fetch student names:", err);
      }
    };

    fetchFilteredStudentNames();
  }, [form.gender, form.grade]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(`/api/schooluniform/update/${id}`, {
        ...form,
        mode,
      });

      // Success popup
      swal({
        title: "Success!",
        text: "Form submitted successfully.",
        icon: "success",
        button: "OK",
      });

      // Optionally reset the form
      setForm({
        enrollment: "",
        student: "",
        gender: "",
        grade: "",
        group: "",
        products: [],
      });
    } catch (err) {
      console.error(err);

      // Error popup
      const errorMsg = err.response?.data?.message || "Something went wrong!";
      swal({
        title: "Error",
        text: errorMsg,
        icon: "error",
        button: "OK",
      });
    }
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <SchoolSidebar />
      <div
        className="container mt-5 p-3 shadow-lg rounded-4 bg-light border mb-4 w-full"
        // style={{ maxWidth: "800px" }}
      >
        <div style={{ width: "80%", margin: "0 auto" }}>
          <h3 className="mb-4 text-center fw-bold text-primary">
            Update Student Selection Form
          </h3>

          <Form
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
            }}
          >
            {/* Enrollment - Single Row */}
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Enrollment No</Form.Label>

                <Form.Control
                  list="enrollment-list"
                  name="enrollment"
                  value={form.enrollment}
                  onChange={handleChange}
                  // disabled={
                  //   form.student !== "" ||
                  //   form.gender !== "" ||
                  //   form.grade !== ""
                  // }
                  placeholder="Type or select enrollment"
                />

                <datalist id="enrollment-list">
                  {enrollmentNumbers.map((e, index) => (
                    <option key={index} value={e}>
                      {e}
                    </option>
                  ))}
                </datalist>
              </Form.Group>
            </div>
            <div className="text-center fw-bold">OR</div>

            {/* Student Name + Gender */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Select {mode === "group" ? "Group" : "Bundle"}
                  </Form.Label>

                  {/* Dropdown */}
                  <Form.Select
                    name="group"
                    value={form.group}
                    onChange={handleChange}
                  >
                    <option value="">
                      Select {mode === "group" ? "Group" : "Bundle"}
                    </option>

                    {gorb.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Gender</Form.Label>
                  <Form.Select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    // disabled={form.enrollment !== ""}
                  >
                    <option>Select Gender</option>
                    {genders.map((g) => (
                      <option key={g} value={g}>
                        {g}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            {/* Grade + Group/Bundle */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Grade</Form.Label>
                  <Form.Select
                    name="grade"
                    value={form.grade}
                    onChange={handleChange}
                  >
                    <option>Select Grade</option>
                    {grades.map((g) => (
                      <option key={g.id} value={g.id}>
                        {g.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Student Name</Form.Label>

                  <Form.Control
                    list="students-list"
                    name="student"
                    value={form.student}
                    onChange={handleChange}
                    placeholder="Type or select student"
                  />

                  <datalist id="students-list">
                    {studentNames?.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </datalist>
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
        {/* PRODUCT LIST BELOW FORM */}
        {products.length > 0 && (
          <div className="mt-4 p-3 shadow rounded bg-white">
            <h4 className="mb-3 text-primary fw-bold">Product List</h4>

            <table className="table table-hover table-striped border rounded">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Size</th>
                  <th>Qty</th>
                </tr>
              </thead>

              <tbody>
                {products?.map((p, index) => (
                  <tr key={index}>
                    {/* Product Name */}
                    <td>{p?.name}</td>

                    {/* Sizes Dropdown */}
                    <Form.Select
                      value={form.products?.[index]?.variantId || ""}
                      onChange={(e) => handleSizeChange(index, e.target.value)}
                    >
                      <option value="">-- Select size --</option>

                      {p.sizes?.map((s, i) => (
                        <option key={i} value={s.variantId}>
                          {s.size}
                        </option>
                      ))}
                    </Form.Select>

                    {/* Quantity Input */}
                    <td>
                      <Form.Control
                        type="number"
                        min="0"
                        value={form.products?.[index]?.quantity || 0}
                        onChange={(e) =>
                          handleQuantityChange(index, Number(e.target.value))
                        }
                        disabled={mode !== "group"}
                        readOnly={mode !== "group"}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="text-end mt-3">
              <Button variant="primary" onClick={handleSubmit}>
                Update Order
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
